export const displayItem = (item: Record<string, unknown> | string | null | undefined, key: string): string => {
  if (item == null || item === undefined) {
    return ''
  }

  if (typeof item === 'object') {
    const value = item[key]

    if (typeof value === 'number') {
      return `${value}`
    }

    if (typeof value !== 'string') {
      return ''
    }

    return value // translateEnabled.value ? localeTexts.value[value] : value
  }

  return item
}
